import * as React from 'react'
import DialogTitle from '@mui/material/DialogTitle'
import Button from '@mui/material/Button'

import Grid from '@mui/material/Grid'

import DialogContent from '@mui/material/DialogContent'
import IconButton from '@mui/material/IconButton'
import CloseIcon from '@mui/icons-material/Close'
import DialogContentText from '@mui/material/DialogContentText'
import DialogActions from '@mui/material/DialogActions'
import Dialog from '@mui/material/Dialog'
import LoadingButton from '@mui/lab/LoadingButton'

import { renderImportOptionsMenu } from './SubImportMenuItem'

import Stepper from '@mui/material/Stepper'
import Step from '@mui/material/Step'
import StepLabel from '@mui/material/StepLabel'
import StepButton from '@mui/material/StepButton'

import Typography from '@mui/material/Typography'
import Box from '@mui/material/Box'
import Chip from '@mui/material/Chip'

import ArrowForwardIcon from '@mui/icons-material/ArrowForwardOutlined'
import EditableSelect from '../EditableSelect'
import TextField from '@mui/material/TextField'

import {
    useContextsStore,
    selectOwnedContexts,
} from '../../stores/useContextsStore'
import { UserContext } from '../../UserContext'

import { useTheme } from '@mui/material/styles'

import { SubImportContext } from './SubImportContext'
import { DialogsContext } from '../../DialogsContext'

import Select from '@mui/material/Select'
import MenuItem from '@mui/material/MenuItem'
import FormControl from '@mui/material/FormControl'
import InputLabel from '@mui/material/InputLabel'
import Divider from '@mui/material/Divider'
import FormHelperText from '@mui/material/FormHelperText'
import FormControlLabel from '@mui/material/FormControlLabel'

import Switch from '@mui/material/Switch'

import axios from 'axios'
import qs from 'qs'

import { slugifyString, convertGPTResponsesToArray } from '../../utils/index'
import { generateTextImportItems } from './TextImportItems'
import AdvancedImportSettings from './AdvancedImportSettings'
import ImportingNotice from './ImportingNotice'
import { useSimplifiedImportAtMount } from '../../hooks/useSimplifiedImportAtMount'
import { chipHoverAccent } from '../../theme'
import { importErrorMessage } from './importError'

const steps = ['Start', 'Sources', 'Settings', 'Results']

export default function AiTopicsImportDialog({
    presetContext = '',
    presetSearchString = '',
    open,
    onClose,
}) {
    const theme = useTheme() // hook to get the current theme

    const {
        activeSubImportDialog,
        setActiveSubImportDialog,
    } = React.useContext(SubImportContext)

    const {
        activeImportDialog,
        setActiveImportDialog,
        backLinkDialog,
        openImportDialog,
        closeImportDialog,
        setPresetSearchString,
    } = React.useContext(DialogsContext)

    // Shared across all import sources so the typed query persists when switching
    const searchString = presetSearchString
    const setSearchString = setPresetSearchString

    const [selectedContext, setSelectedContext] = React.useState(presetContext)

    const [errorMessage, setErrorMessage] = React.useState(null)

    const [importError, setImportError] = React.useState(null)

    const [completedSteps, setCompletedSteps] = React.useState([])

    const [visitedContext, setVisitedContext] = React.useState(false)

    const [numberOfResults, setNumberOfResults] = React.useState('20')

    const [modelToUse, setModelToUse] = React.useState('claude-opus-5-5')

    const [hideSearchTerms, setHideSearchTerms] = React.useState(true)

    const [modifyAnalyzedText, setModifyAnalyzedText] = React.useState('none')

    const [replaceEntities, setReplaceEntities] = React.useState(false)

    const menuItems = generateTextImportItems()

    console.log('menuItems', menuItems)
    const filteredMenuItems = menuItems.filter(
        ({ textInput }) =>
            textInput.includes('aiTopics') ||
            textInput.includes('aiOntologies') ||
            textInput.includes('aiGraphs') ||
            textInput.includes(backLinkDialog)
    )
    const { username } = React.useContext(UserContext)

    const [contextTypeToUse, setContextTypeToUse] = React.useState('STANDARD')

    const contexts = useContextsStore(selectOwnedContexts)
    const contextNames = contexts.map(c => c.name)

    const simplifyImport = useSimplifiedImportAtMount()

    const [activeStep, setActiveStep] = React.useState(2)
    const [skipped, setSkipped] = React.useState(new Set())

    const handleNext = () => {
        let newSkipped = skipped

        setActiveStep(prevActiveStep => prevActiveStep + 1)
        setSkipped(newSkipped)
    }

    const handleBack = () => {
        setActiveStep(prevActiveStep => prevActiveStep - 1)
    }

    const handleStep = step => {
        setActiveStep(step)
    }

    const handleNumberOfResultsChange = event => {
        setNumberOfResults(event.target.value)
    }

    const handleSearchStringChange = event => {
        setSearchString(event.target.value)
    }

    const handleSearchLanguageChange = event => {
        setSearchLanguage(event.target.value)
    }

    const handleSearchCountryChange = event => {
        setSearchCountry(event.target.value)
    }

    React.useEffect(() => {
        if (activeSubImportDialog.type) {
            setActiveStep(2)
            setActiveImportDialog(activeSubImportDialog.type)
        }
    }, [activeSubImportDialog])

    React.useEffect(() => {
        switch (activeStep) {
            case 0: // Start
                setActiveSubImportDialog(false)
                setActiveImportDialog('import')
                break
            case 1: // Sources
                setActiveSubImportDialog(false)
                setActiveImportDialog('shortTextImport')
                break
            case 2: // Settings
                if (!presetContext) {
                    setSelectedContext(generatePresetContext(searchString))
                }
                break
            case 3: // Analysis
                if (!searchString) {
                    setErrorMessage(
                        `Please, provide a search query you'd like to get results from AI for.`
                    )
                    setActiveStep(2)
                    break
                }
                if (!selectedContext) {
                    setErrorMessage(
                        'Please, select the graph to import your data to.'
                    )
                    setActiveStep(2)
                    break
                }
                if (selectedContext) {
                    setCompletedSteps([...completedSteps, 3])
                    setErrorMessage(null)
                    submitDataForm()
                    break
                }
        }
    }, [activeStep])

    React.useEffect(() => {
        setContextTypeToUse(
            modifyAnalyzedText == 'extractEntitiesOnly' ||
                modifyAnalyzedText == 'detectEntities'
                ? 'WIKILINKS'
                : 'STANDARD'
        )
    }, [modifyAnalyzedText])

    const submitDataForm = () => {
        const dataToSend = {
            saveToGraphAndRedirect: true,
            contextName: selectedContext,
            aiQueryType: 'llm graph',
            mode: 'gptchat',
            modelToUse: modelToUse,
            prompt: [{ role: 'user', content: searchString }],
            numberOfResults: numberOfResults,
            receivedModel: 'default',
            excludesearchquery: hideSearchTerms ? '1' : '',
            modifyAnalyzedText: modifyAnalyzedText,
            replaceEntities: replaceEntities,
            contextType: contextTypeToUse,
        }

        const dataAsForm = qs.stringify(dataToSend)

        axios
            .post(`/graph/${username}/openai`, dataAsForm, {
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded', // Sending as URL-encoded form data
                },
            })
            .then(response => {
                if (response.data.redirectUrl) {
                    // If you're using window.location
                    window.location.href = response.data.redirectUrl

                    // Or, if you're using React Router's history (assuming you have access to the history object)
                    // history.push(response.data.redirectUrl);
                } else {
                    console.error(`Did't receive any response from the server.`)
                    if (response.data.error) {
                        setErrorMessage(
                            typeof response.data.error == 'object'
                                ? response.data.error.error ||
                                      JSON.stringify(response.data.error)
                                : response.data.error
                        )
                        setImportError(response.data.error)
                        setActiveStep(2)
                    }
                }
            })
            .catch(error => {
                // Handle the error here
                console.error('Received the following error', error)
                setErrorMessage(importErrorMessage(error))
                setImportError(response.data.error)
            })
    }

    return (
        <>
            <Dialog
                open={open}
                onClose={onClose}
                fullWidth={true}
                maxWidth="lg"
            >
                <DialogTitle
                    sx={{
                        padding: 4,
                        color: theme => theme.palette.text.primary,
                        display: 'flex',
                        justifyContent: 'space-between',
                        alignItems: 'center',
                    }}
                >
                    {'Generate a graph of how AI sees a topic'}
                    <IconButton
                        edge="end"
                        color="inherit"
                        onClick={onClose}
                        aria-label="close"
                    >
                        <CloseIcon />
                    </IconButton>
                </DialogTitle>
                {/* A stepper whose labels submit on click would be the most prominent control left. */}
                {!simplifyImport && (
                    <Stepper
                        activeStep={activeStep}
                        sx={{ paddingLeft: 4, paddingRight: 4, paddingTop: 2 }}
                    >
                        {steps.map((label, index) => {
                            const stepProps = {}
                            const labelProps = {}

                            return (
                                <Step key={label} {...stepProps}>
                                    <StepButton
                                        onClick={() => handleStep(index)}
                                        completed={(
                                            completedSteps.indexOf(index) >= 0
                                        ).toString()}
                                    >
                                        <StepLabel
                                            {...labelProps}
                                            sx={{
                                                '& .MuiStepLabel-label': {
                                                    fontSize: {
                                                        xs: '0.75rem',
                                                        sm: 'initial',
                                                    },
                                                },
                                            }}
                                        >
                                            {label}
                                        </StepLabel>
                                    </StepButton>
                                </Step>
                            )
                        })}
                    </Stepper>
                )}

                {errorMessage && (
                    <Typography
                        sx={{
                            paddingRight: 4,
                            paddingLeft: 4,
                            paddingTop: 4,
                            paddingBottom: 0,
                        }}
                        color="error"
                        component="div"
                        gutterBottom
                    >
                        {errorMessage}
                    </Typography>
                )}

                {activeStep === 2 && (
                    <>
                        <DialogContent
                            sx={{
                                paddingRight: 4,
                                paddingLeft: 4,
                                paddingTop: 4,
                            }}
                        >
                            <DialogContentText>
                                Describe the topic for which you want to
                                generate a knowledge graph:
                            </DialogContentText>

                            <Grid container spacing={8}>
                                <Grid item xs={12} sm={simplifyImport ? 12 : 7}>
                                    <FormControl
                                        fullWidth
                                        sx={{ marginTop: 4 }}
                                    >
                                        <TextField
                                            label={
                                                'e.g. "machine learning" or "movement practices"'
                                            }
                                            value={searchString}
                                            variant="outlined"
                                            onChange={handleSearchStringChange}
                                            aria-describedby="searchString-helperText"
                                            sx={{
                                                '& .MuiOutlinedInput-root': {
                                                    '& fieldset': {
                                                        borderWidth: 2,
                                                        borderColor:
                                                            'info.main',
                                                    },
                                                    '&:hover fieldset': {
                                                        borderWidth: 2,
                                                        borderColor:
                                                            'info.dark',
                                                    },
                                                    '&.Mui-focused fieldset': {
                                                        borderWidth: 2,
                                                    },
                                                },
                                            }}
                                        />
                                        <FormHelperText
                                            id="searchString-helperText"
                                            sx={{ marginTop: 2 }}
                                        >
                                            We will use the AI model you choose
                                            to generate several statements that
                                            relate to the topic. Choose
                                            "detected entities" to build a
                                            sparser knowledge graph.
                                        </FormHelperText>
                                        <Box
                                            sx={{
                                                display: 'flex',
                                                flexWrap: 'wrap',
                                                alignItems: 'center',
                                                gap: 1.5,
                                                mt: 2.5,
                                            }}
                                        >
                                            <Typography
                                                variant="body2"
                                                color="text.secondary"
                                                sx={{ fontWeight: 500 }}
                                            >
                                                try one of these:
                                            </Typography>
                                            {[
                                                {
                                                    label: 'ai agents',
                                                    value: 'ai agents',
                                                },
                                                {
                                                    label: 'body practices',
                                                    value: 'body practices',
                                                },
                                                {
                                                    label:
                                                        'political movements',
                                                    value:
                                                        'political movements',
                                                },
                                                {
                                                    label: 'macbook pro',
                                                    value: 'macbook pro',
                                                },
                                            ].map(suggestion => (
                                                <Chip
                                                    key={suggestion.label}
                                                    label={suggestion.label}
                                                    size="medium"
                                                    variant="outlined"
                                                    onClick={() => {
                                                        setSearchString(
                                                            suggestion.value
                                                        )
                                                    }}
                                                    sx={{
                                                        cursor: 'pointer',
                                                        fontSize: '0.85rem',
                                                        fontWeight: 500,
                                                        borderColor:
                                                            'rgba(0, 200, 200, 0.5)',
                                                        color: 'info.main',
                                                        '&:hover': {
                                                            color: chipHoverAccent,
                                                            borderColor: chipHoverAccent,
                                                        },
                                                    }}
                                                />
                                            ))}
                                        </Box>
                                    </FormControl>
                                    <FormControl
                                        fullWidth
                                        sx={{ marginTop: 6 }}
                                    >
                                        <DialogContentText>
                                            Using the import app:
                                        </DialogContentText>
                                        <DialogContent
                                            sx={{
                                                pl: 0,
                                                ml: 0.5,
                                                marginTop: 0.5,
                                                '& .MuiList-root': {
                                                    p: 0,
                                                },
                                                '& .MuiListItem-root': {
                                                    py: 0.5,
                                                },
                                            }}
                                        >
                                            {renderImportOptionsMenu(
                                                filteredMenuItems,
                                                'aiTopics'
                                            )}
                                        </DialogContent>
                                    </FormControl>
                                </Grid>
                                <Grid
                                    item
                                    xs={12}
                                    sm={simplifyImport ? 12 : 4}
                                    sx={{
                                        marginTop: 0,
                                        marginBottom: 4,
                                    }}
                                >
                                    {/* Stays visible for a guided user: the one setting worth asking. */}
                                    <FormControl
                                        fullWidth
                                        sx={{
                                            marginTop: 4,
                                            marginBottom: 2,
                                        }}
                                    >
                                        <InputLabel id="modelToUse-label">
                                            AI Model to Use
                                        </InputLabel>
                                        <Select
                                            labelId="modelToUse-label"
                                            id="modelToUse"
                                            value={modelToUse}
                                            onChange={event =>
                                                setModelToUse(
                                                    event.target.value
                                                )
                                            }
                                            label="AI Model to Use"
                                        >
                                            <MenuItem value={'gpt-4o'}>
                                                GPT-4o
                                            </MenuItem>
                                            <MenuItem value={'gpt-4o-mini'}>
                                                GPT-4o-mini (faster)
                                            </MenuItem>
                                            <MenuItem value={'gpt-5.4'}>
                                                Auto
                                            </MenuItem>
                                            <MenuItem value={'gpt-5.4-mini'}>
                                                GPT-5.4-mini (reasoning)
                                            </MenuItem>
                                            <MenuItem value={'gpt-5.6-terra'}>
                                                GPT-5.6 Terra
                                            </MenuItem>
                                            <MenuItem value={'gpt-5.6-sol'}>
                                                GPT-5.6 Sol
                                            </MenuItem>
                                            <MenuItem value={'gpt-6.1-terra'}>
                                                GPT-6.1 Terra
                                            </MenuItem>
                                            <MenuItem value={'gpt-6.1-sol'}>
                                                GPT-6.1 Sol
                                            </MenuItem>
                                            <MenuItem value={'gpt-4'}>
                                                GPT-4 (older but comprehensive)
                                            </MenuItem>
                                            <MenuItem value={'gpt-3.5-turbo'}>
                                                GPT-3.5 (Turbo)
                                            </MenuItem>
                                            <Divider sx={{ my: 0.5 }} />
                                            <MenuItem value={'claude-opus-5-5'}>
                                                Claude Opus 5.5 (most powerful)
                                            </MenuItem>
                                            <MenuItem value={'claude-sonnet-5-5'}>
                                                Claude Sonnet 5.5 (balanced)
                                            </MenuItem>
                                            <MenuItem value={'claude-fable-5-1'}>
                                                Claude Fable 5.1 (most advanced)
                                            </MenuItem>
                                            <Divider sx={{ my: 0.5 }} />
                                            <MenuItem
                                                value={'gemini-3.8-flash'}
                                            >
                                                Gemini 3.8 Flash
                                            </MenuItem>
                                            <MenuItem
                                                value={'gemini-3.5-flash-lite'}
                                            >
                                                Gemini 3.5 Flash Lite (faster)
                                            </MenuItem>
                                            <Divider sx={{ my: 0.5 }} />
                                            <MenuItem
                                                value={
                                                    'grok-4.7'
                                                }
                                            >
                                                Grok 4.7 (reasoning)
                                            </MenuItem>
                                            <MenuItem
                                                value={
                                                    'grok-4.20-0309-non-reasoning'
                                                }
                                            >
                                                Grok 4.20 (fast)
                                            </MenuItem>
                                        </Select>
                                    </FormControl>
                                    <AdvancedImportSettings>
                                        <FormControl
                                            fullWidth
                                            sx={{
                                                marginTop: 4,
                                                marginBottom: 2,
                                            }}
                                        >
                                            <EditableSelect
                                                selectItems={contextNames}
                                                label={'Graph Name'}
                                                initialValue={selectedContext}
                                                onChange={name =>
                                                    setSelectedContext(name)
                                                }
                                            />
                                        </FormControl>
                                        <FormControl
                                            fullWidth
                                            sx={{
                                                marginTop: 4,
                                                marginBottom: 2,
                                            }}
                                        >
                                            <InputLabel id="modifyAnalyzedText-label">
                                                Build a knowledge graph from
                                            </InputLabel>
                                            <Select
                                                labelId="modifyAnalyzedText-label"
                                                id="modifyAnalyzedText"
                                                value={modifyAnalyzedText}
                                                onChange={event =>
                                                    setModifyAnalyzedText(
                                                        event.target.value
                                                    )
                                                }
                                                label="Build a knowledge graph from"
                                            >
                                                <MenuItem
                                                    value={'none'}
                                                    key="1"
                                                >
                                                    the words used in text
                                                </MenuItem>
                                                <MenuItem
                                                    value={'detectEntities'}
                                                    key="2"
                                                >
                                                    the words and detected
                                                    entities
                                                </MenuItem>
                                                <MenuItem
                                                    value={
                                                        'extractEntitiesOnly'
                                                    }
                                                    key="3"
                                                >
                                                    only the detected entities
                                                </MenuItem>
                                            </Select>
                                            {modifyAnalyzedText == 'none' && (
                                                <FormHelperText
                                                    sx={{ marginTop: 1 }}
                                                >
                                                    By default, we build a graph
                                                    from words, not entities, as
                                                    it provides a richer topical
                                                    structure.
                                                </FormHelperText>
                                            )}
                                            {modifyAnalyzedText != 'none' && (
                                                <FormHelperText
                                                    sx={{ marginTop: 1 }}
                                                >
                                                    You can also choose to
                                                    detect and tag entities in
                                                    your text to build a sparser
                                                    graph.
                                                </FormHelperText>
                                            )}
                                        </FormControl>
                                        {modifyAnalyzedText != 'none' && (
                                            <FormControl
                                                fullWidth
                                                sx={{
                                                    marginTop: 2,
                                                    marginBottom: 2,
                                                }}
                                            >
                                                <FormControlLabel
                                                    control={
                                                        <Switch
                                                            id="replaceEntities"
                                                            checked={
                                                                replaceEntities
                                                            }
                                                            onChange={event =>
                                                                setReplaceEntities(
                                                                    event.target
                                                                        .checked
                                                                )
                                                            }
                                                        />
                                                    }
                                                    label="Replace entities with root concepts"
                                                />
                                                {replaceEntities && (
                                                    <FormHelperText
                                                        id="replaceEntities-helperText"
                                                        sx={{ marginTop: 1 }}
                                                    >
                                                        When turned on, we will
                                                        not only detect the
                                                        entities, but also
                                                        replace them with their
                                                        ontological root
                                                        concepts throughout your
                                                        text.
                                                    </FormHelperText>
                                                )}
                                            </FormControl>
                                        )}
                                        <FormControl
                                            fullWidth
                                            sx={{
                                                marginTop: 4,
                                                marginBottom: 2,
                                            }}
                                        >
                                            <FormControlLabel
                                                control={
                                                    <Switch
                                                        checked={
                                                            hideSearchTerms
                                                        }
                                                        onChange={event =>
                                                            setHideSearchTerms(
                                                                event.target
                                                                    .checked
                                                            )
                                                        }
                                                    />
                                                }
                                                label="Hide Search Terms from Graph"
                                            />

                                            <FormHelperText>
                                                explore the context around the
                                                search query
                                            </FormHelperText>
                                        </FormControl>
                                    </AdvancedImportSettings>
                                </Grid>
                            </Grid>
                        </DialogContent>
                    </>
                )}

                {activeStep === 3 && (
                    <ImportingNotice
                        linkHref={`/${username}/${selectedContext}/edit`}
                    />
                )}
                <DialogActions
                    sx={{
                        paddingRight: 4,
                        paddingLeft: 4,
                        paddingBottom: 4,
                        paddingTop: 2,
                    }}
                >
                    {/* <Button onClick={onClose} variant="outlined">
                        Cancel
                    </Button> */}
                    <Button
                        color="inherit"
                        variant="outlined"
                        disabled={activeStep === 0}
                        onClick={handleBack}
                        sx={{ mr: 1, px: 3, py: 1, fontSize: '0.95rem' }}
                    >
                        Back
                    </Button>

                    <LoadingButton
                        color="info"
                        variant="contained"
                        size="large"
                        endIcon={<ArrowForwardIcon />}
                        disabled={!searchString.length > 0 || activeStep == 3}
                        onClick={handleNext}
                        sx={{ px: 4, py: 1, fontSize: '0.95rem' }}
                    >
                        {simplifyImport && activeStep === 2
                            ? 'Start processing'
                            : activeStep === 2
                            ? 'Visualize'
                            : 'Next'}
                    </LoadingButton>
                </DialogActions>
            </Dialog>
        </>
    )
}

function generatePresetContext(searchString) {
    const dateAndTime = new Date()
        .toISOString()
        .slice(2, 16)
        .replace(/-/g, '')
        .replace(/:/g, '')

    if (!searchString) return `ai_topic_${dateAndTime}`

    const twoFirstSearchQueryWords = slugifyString(
        searchString
            .split(' ')
            .slice(0, 2)
            .join('_')
            .slice(0, 20)
            .replace(/[^\P{L}a-z][^a-z]*/giu, '')
    )

    return `ai_topic_${twoFirstSearchQueryWords}`
}
